export default {
    
    find:   { method: 'get',    url: 'course_levels' },
    create: { method: 'post',   url: 'course_levels'},
    update: { method: 'put',    url: 'course_levels/{id}'},
    delete: { method: 'delete', url: 'course_levels/{id}'},

}